import { Box, Fade, Grid, Typography } from "@mui/material";
import { useContext } from "react";
import { useGtXs } from "../../hooks/useGtXs";
import { useHasInternalRole } from "../../hooks/useHasRole";
import Config from "../../services/config";
import ClearFilters from "../ClearFilters/ClearFilters";
import ContractFilter from "../ContractFilter/ContractFilter";
import CorrectiveRequestsFilter from "../CorrectiveRequestsFilter/CorrectiveRequests";
import { DataViewContext } from "../DataViewProvider/DataViewProvider";
import MoreFilters from "../MoreFilters/MoreFilters";
import RoadFilter from "../RoadFilter/RoadFilter";
import Search from "../Search/Search";
import Show from "../Show/Show";
import SurveyRecordAuthorFilter from "../SurveyRecordAuthorFilter/SurveyRecordAuthorFilter";
import SurveyRecordIsPublishedFilter from "../SurveyRecordIsPublishedFilter/SurveyRecordIsPublishedFilter";
import SurveyRecordStateFilter from "../SurveyRecordStateFilter/SurveyRecordStateFilter";
import activeFiltersCount from "./Helpers/ActiveFiltersCount";
import styles from './SurveyRecordsFilters.module.scss';

export default function SurveyRecordsFilters() {
    const context = useContext(DataViewContext)
    const isInternalUser = useHasInternalRole()
    const gtXs = useGtXs()

    const count = activeFiltersCount(context?.filters)

    const FilterContent = () => (
        <>
            <Search value={context.filters.name} onChange={context.setFilter} name="name" autoFocus={gtXs} />
            <ContractFilter value={context.filters.contract} onChange={context.setFilter} />
            <RoadFilter value={context.filters.road} onChange={context.setFilter} />
            <SurveyRecordStateFilter value={context.filters.state} onChange={context.setFilter} />
            <Show on={isInternalUser}>
                <SurveyRecordIsPublishedFilter value={context.filters.isPublished} onChange={context.setFilter} />
            </Show>
            <CorrectiveRequestsFilter value={context.filters.hasCorrectiveRequests} onChange={context.setFilter} />
            <SurveyRecordAuthorFilter value={context.filters.user} onChange={context.setFilter} />
        </>
    )

    return (
        <Fade in={!context.loading} timeout={Config.DEFAULT_FADE_TIMEOUT}>
            <div>
                {gtXs ? (
                    <Grid container justifyContent="flex-start" alignItems="center" className={styles.SurveyRecordsFilters}>
                        <FilterContent />
                        <div style={{ marginLeft: 20 }}></div>
                        <ClearFilters />
                    </Grid>
                ) : (
                    <Box className={styles.MobileFiltersContainer}>
                        <MoreFilters count={count}>
                            <Box className={styles.DrawerContent}>
                                <Box className={styles.DrawerHeader}>
                                    <Typography variant="h6" color="primary">
                                        Filtros
                                    </Typography>
                                </Box>

                                <Grid container direction="column" className={styles.DrawerFilters} gap={1}>
                                    <FilterContent />
                                </Grid>


                                <Grid container justifyContent="flex-end" className={styles.DrawerFooter}>
                                    <ClearFilters />
                                </Grid>
                            </Box>

                        </MoreFilters>

                    </Box>
                )}
            </div>
        </Fade>
    )
}
